// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-contacts-row {
  margin-bottom: 15px;
  --padding-start: 16px;
}
.skeleton-contacts-row__avatar {
  width: 48px;
  height: 48px;
  margin-inline-end: 12px;
}
.skeleton-contacts-row__avatar ion-skeleton-text {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 50%;
}
.skeleton-contacts-row__label {
  margin: 0;
}
.skeleton-contacts-row__line {
  margin: 0 0 6px;
}
.skeleton-contacts-row__line ion-skeleton-text {
  margin: 0;
  height: 16px;
}
.skeleton-contacts-row__line--name ion-skeleton-text {
  width: 55%;
}
.skeleton-contacts-row__line--role ion-skeleton-text {
  width: 38%;
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/contacts/skeleton-contacts-row/skeleton-contacts-row.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AACN;AAGE;EACE,SAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EACE,SAAA;EACA,YAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,UAAA;EACA,YAAA;AAJN","sourcesContent":[".skeleton-contacts-row {\n  margin-bottom: 15px;\n  --padding-start: 16px;\n\n  &__avatar {\n    width: 48px;\n    height: 48px;\n    margin-inline-end: 12px;\n\n    ion-skeleton-text {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 50%;\n    }\n  }\n\n  &__label {\n    margin: 0;\n  }\n\n  &__line {\n    margin: 0 0 6px;\n\n    ion-skeleton-text {\n      margin: 0;\n      height: 16px;\n    }\n\n    &--name ion-skeleton-text {\n      width: 55%;\n    }\n\n    &--role ion-skeleton-text {\n      width: 38%;\n      height: 14px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
